import { z } from "zod";
import { VictimStatusZ } from "./enums/victim-status";

export const VictimDTOz = z
  .object({
    id: z.string().nullable(),
    name: z.string().nullable(),
    pictureLink: z.string().url().nullable(),
    dateOfBirth: z.string().datetime().nullable(),
    placeOfBirth: z.string().nullable(),
    addressOfCrime: z.string().nullable(),
    status: VictimStatusZ.nullable(),
    killerId: z.string().nullable(),
    dateOfCrime: z.string().datetime().nullable(),
    lat: z.number().nullable(),
    lng: z.number().nullable(),
    region: z.string().nullable().optional().default(null),
    country: z.string().nullable(),
    age: z.number().int().nonnegative().nullable(),
    gender: z.string().nullable(),
    causeOfDeath: z.string().nullable(),
    wikipediaLink: z.string().url().nullable(),
    race: z.string().nullable().optional().default(null),
    height: z.string().nullable().optional().default(null),
    weight: z.string().nullable().optional().default(null),
    hairColor: z.string().nullable().optional().default(null),
  })
  .passthrough();

export type VictimDTO = z.infer<typeof VictimDTOz>;